import NavigationDesktopSticky from './navigation-desktop-sticky/script';
import NavigationMobile from './navigation-mobile/script';
import NavigationPrimary from './navigation-primary/script';

export default {
	[NavigationDesktopSticky.selector]: NavigationDesktopSticky,
	[NavigationMobile.selector]: NavigationMobile,
	[NavigationPrimary.selector]: NavigationPrimary
};
